<template>
  <div class="header-container">
    <div class="header-content">
      <router-link to="/" class="logo" @mousedown.native="logoClick();$ga.event('header', 'logo');">
        FLAT UI COLORS 2
      </router-link>
      <div class="top-menu">
        <a href="https://go.panda.network/fuic-ddr" target="_blank">
          Designer Inspiration <span>NEW</span>
        </a>
        <router-link to="/subscribe" @click.native="$ga.event('header', 'subscribe');">
          Subscribe
        </router-link>
        <router-link v-if="false" to="/submit" @click.native="$ga.event('header', 'submit');">
          Submit
        </router-link>
        <a href="javascirpt:;" style="display:none;">More Products</a>
        <a style="display:none;" href="https://medium.com/collect-ui-design-ui-ux-inspiration-blog/flat-ui-colors-2-13-countries-13-designers-13-color-palettes-more-1d0ecdd66301" target="_blank" @click="$ga.event('header', 'about');">About</a>
      </div>
    </div>
    <!-- /.header-content -->
    <div class="pads" ref="el"></div>
  </div>
</template>

<script>
let isMobile = false;

if (
  navigator.userAgent.match(/Android/i) ||
  navigator.userAgent.match(/webOS/i) ||
  navigator.userAgent.match(/iPhone/i) ||
  navigator.userAgent.match(/iPod/i) ||
  navigator.userAgent.match(/iPad/i) ||
  navigator.userAgent.match(/BlackBerry/i) ||
  navigator.userAgent.match(/IEMobile/i) ||
  navigator.userAgent.match(/Opera Mini/i)
) {
  isMobile = true;
}

function isMacDesktop() {
    // Modern browsers often set navigator.platform to "MacIntel" on macOS desktops
    const platform = navigator.platform.toLowerCase();

    // Check common macOS desktop platform indicators.
    // "MacIntel" is a common value for macOS desktop platforms.
    const isMac = platform.includes("macintel");

    // Now ensure the user isn't on an iOS device.
    // iOS devices that run Safari also often appear as "like Mac OS X" in user agents,
    // but we can exclude them by checking for mobile indicators.
    const userAgent = navigator.userAgent.toLowerCase();
    const isMobile = /iphone|ipad|ipod|android|mobile/.test(userAgent);

    return isMac && !isMobile;
}

// Array of phrases
const phrases = [
  "Free Video Optimization App",
  "Free Image Optimization App",
  "Free Image Conversion App",
  "Free Youtube Downloader App"
];

// Function to get a random phrase
function getRandomPhrase() {
  const randomIndex = Math.floor(Math.random() * phrases.length);
  return phrases[randomIndex];
}

export default {
  name: "Header",
  components: {},
  data() {
    return {
      isMac: isMacDesktop(),
      randomPhrase: getRandomPhrase(),
      showDDR: !isMobile && window.chrome !== undefined
    };
  },
    mounted(){
      window.pads(this.$refs.el, { name: 'flatuicolors.com'}, window.location.href.indexOf("showDailyData") != -1 ? true : false );
    },
  methods: {
    logoClick() {
      // window.logoSound.play();
      window.sounds.logoSound.currentTime = 0;
      window.sounds.logoSound.play();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/common.scss";
.header-container {
  display: block;
  width: 1024px;
  // background: red;
  text-align: left;
  position: relative;
  height: 65px;
  box-sizing: border-box;
  margin-bottom: 15px;
    .header-content{
    width: 100% !important;
    display: flex;
    align-content: center;
    justify-content: center;
    float: left;
    height: 105px;
  }
  .pads{
    position: absolute;
    // background: red;
    top: 24px;
    left: 50%;
    margin-left: -140px;
  }
  .logo {
    font-size: 24px;
    color: #fff;
    position: absolute;
    left: 2px;
    bottom: 5px;
    letter-spacing: 2.5px;
    font-weight: 600;
    text-shadow: 0px 1px, 1px 0px, 1px 1px;
    user-select: none;
    transition: all 0.2s;
    transform-origin: 0% 50%;
  }
  .top-menu {
    // background: green;
    position: absolute;
    right: 0px;
    bottom: 5px;
    margin-right: 2px;
    font-weight: bolder;
    letter-spacing: 1px;
    a {
      margin-left: 40px;
      font-weight: 600;
      font-size: 17px;
      color: #fff;
      display: inline-block;
      transition: all 0.2s;
      position: relative;
      @include link-effect();
      span{
        background: red;
        font-size: 14px;
        font-weight: bold;
        padding: 2px 4px;
        padding-left: 6px;
        border-radius: 4px;
        margin-left: 8px;
      }
      &:after {
        height: 2px;
        bottom: -4px;
      }
    }
  }
  a:active {
    transform: scale(0.95);
  }
}
@media (max-width: 600px) {
  .header-container {
    width: 100%;
    .top-menu {
      display: none;
    }
  }
}
</style>
<style lang="scss">
  .ph-modal{
    color: #000 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue